import { createSlice } from '@reduxjs/toolkit'
import { useCookies } from 'react-cookie'


export const profileSlice = createSlice({
  name: 'profile',
  initialState: {
   business: {},
   businessAddress: {},
   profile:[],
   loadata:[],
   titleThai:'',
   titleEng:'',
   nameThai:'',
   nameEng:'',
   lastnameThai:'',
   lastnameEng:'',
   birthday:'',
   idCardNumber:'',
   staffId:'',
   position:[],
   department:[],
   onemail:[],
   phoneNumber:[],
   email:[],
   step:'',
   addemail:false,
   addemailcolor:false,
   mainPhoneNumber:[]
  },
  reducers: {
    setAddEmailRedux: (state, action) => {
      const { addemail } = action.payload
      state.addemail = addemail
    },
    setAddEmailColorRedux: (state, action) => {
      const { addemailcolor } = action.payload
      state.addemailcolor = addemailcolor
    },
    setBusinessRedux: (state, action) => {
      const { business } = action.payload
      state.business = business
    },
    setBusinessAddressRedux: (state, action) => {
      const { businessAddress } = action.payload
      state.businessAddress = businessAddress
    },
    setProfileRedux: (state, action) => {
      const { profile } = action.payload
      state.profile = profile
    },
    setLoaDataRedux: (state, action) => {
      const { loadata } = action.payload
      state.loadata = loadata
    },
    setTitleThaiRedux: (state, action) => {
      const { titleThai } = action.payload
      state.titleThai = titleThai
    },
    setTitleEngRedux: (state, action) => {
      const { titleEng } = action.payload
      state.titleEng = titleEng
    },
    setNameThaiRedux: (state, action) => {
      const { nameThai } = action.payload
      state.nameThai = nameThai
    },
    setNameEngRedux: (state, action) => {
      const { nameEng } = action.payload
      state.nameEng = nameEng
    },
    setLastNameThaiRedux: (state, action) => {
      const { lastnameThai } = action.payload
      state.lastnameThai = lastnameThai
    },
    setLastNameEngRedux: (state, action) => {
      const { lastnameEng } = action.payload
      state.lastnameEng = lastnameEng
    },
    setBirthDayRedux: (state, action) => {
      const { birthday } = action.payload
      state.birthday = birthday
    },
    setIdCardNumberRedux: (state, action) => {
      const { idCardNumber } = action.payload
      state.idCardNumber = idCardNumber
    },
    setStaffIDRedux: (state, action) => {
      const { staffId } = action.payload
      state.staffId = staffId
    },
    setPositionRedux: (state, action) => {
      const { position } = action.payload
      state.position = position
    },
    setDepartmentRedux: (state, action) => {
      const { department } = action.payload
      state.department = department
    },
    setOneMailRedux: (state, action) => {
      const { onemail } = action.payload
      state.onemail = onemail
    },
    setPhoneNumberRedux: (state, action) => {
      const { phoneNumber } = action.payload
      state.phoneNumber = phoneNumber
    },
    setEmailRedux: (state, action) => {
      const { email } = action.payload
      state.email = email
    },
    setStepRedux: (state, action) => {
      const { step } = action.payload
      state.step = step
    },
    setMainPhoneNumberRedux: (state, action) => {
      const { mainPhoneNumber } = action.payload
      state.mainPhoneNumber = mainPhoneNumber
    },
  }
})

export default profileSlice.reducer;

export const {
  setAddEmailRedux,
  setAddEmailColorRedux,
  setBusinessRedux,
  setBusinessAddressRedux,
  setProfileRedux,
  setLoaDataRedux,
  setTitleThaiRedux,
  setTitleEngRedux,
  setNameThaiRedux,
  setNameEngRedux,
  setLastNameThaiRedux,
  setLastNameEngRedux,
  setBirthDayRedux,
  setIdCardNumberRedux,
  setStaffIDRedux,
  setPositionRedux,
  setDepartmentRedux,
  setOneMailRedux,
  setPhoneNumberRedux,
  setEmailRedux,
  setStepRedux,
  setMainPhoneNumberRedux

} = profileSlice.actions


export const getBusinessRedux = (state) => state.profile.business
export const getAddEmailRedux = (state) => state.profile.addemail
export const getAddEmailColorRedux = (state) => state.profile.addemailcolor
export const getBusinessAddressRedux = (state) => state.profile.businessAddress
export const getTitleThaiRedux = (state) => state.profile.titleThai
export const getTitleEngRedux = (state) => state.profile.titleEng
export const getProfileRedux = (state) => state.profile.profile
export const getLoaDataRedux = (state) => state.profile.loadata
export const getNameThaiRedux = (state) => state.profile.nameThai
export const getNameEngRedux = (state) => state.profile.nameEng
export const getLastNameThaiRedux = (state) => state.profile.lastnameThai
export const getLastNameEngRedux = (state) => state.profile.lastnameEng
export const getBirthDayRedux = (state) => state.profile.birthday
export const getIdCardNumberRedux = (state) => state.profile.idCardNumber
export const getStaffIDRedux = (state) => state.profile.staffId
export const getPositionRedux = (state) => state.profile.position
export const getDepartmentRedux = (state) => state.profile.department
export const getOneMailRedux = (state) => state.profile.onemail
export const getPhoneNumberRedux = (state) => state.profile.phoneNumber
export const getEmailRedux = (state) => state.profile.email
export const getStepRedux = (state) => state.profile.step
export const getMainPhoneNumberRedux = (state) => state.profile.mainPhoneNumber






















